import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["messengers", "isChatOpen", "isMenuOpen", "onClick", "dispatch", "children"];
import React, { forwardRef, useMemo } from 'react';
import { cnBem } from '@carnica/utils';
import { connect } from 'react-redux';
import { AnimatedIconProvider, IconCloseRoundStroked, IconDotsMessageFilled, defineAnimatedIcon } from '@carnica/graphics';
import { Button } from "../../../../shared/ui";
import { selectChatCofig, selectIsChatOpen, selectIsMenuOpen, setChatOpen, setMenuOpen } from "../../../../entities/settings/model";
import { setStoreImgPreview } from "../../../../entities/message/model";
import styles from "./styles.pcss";
var cnStartButton = cnBem('start-button', styles);
var Icon = defineAnimatedIcon({
  icons: [IconDotsMessageFilled, IconCloseRoundStroked]
});
var OpenChatRender = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$messengers = props.messengers,
    messengers = _props$messengers === void 0 ? [] : _props$messengers,
    isChatOpen = props.isChatOpen,
    isMenuOpen = props.isMenuOpen,
    onClick = props.onClick,
    dispatch = props.dispatch,
    children = props.children,
    otherProps = _objectWithoutProperties(props, _excluded);
  var setIsMenuOpen = function setIsMenuOpen(flag) {
    return dispatch(setMenuOpen(flag));
  };
  var setIsChatOpen = function setIsChatOpen(flag) {
    return dispatch(setChatOpen(flag));
  };
  var setImgPreview = function setImgPreview(imgPreview) {
    return dispatch(setStoreImgPreview(imgPreview));
  };
  var handleClick = function handleClick(e) {
    if (isChatOpen || isMenuOpen) {
      setIsChatOpen(false);
      setIsMenuOpen(false);
      setImgPreview({
        isImgPreviewOpen: false,
        type: null
      });
    } else if (messengers.length > 1) {
      setIsMenuOpen(true);
    } else {
      setIsMenuOpen(false);
      setIsChatOpen(true);
    }
    onClick === null || onClick === void 0 || onClick(e);
  };
  var ariaLabel = useMemo(function () {
    if (messengers.length <= 1) {
      return isChatOpen ? 'Закрыть чат' : 'Открыть чат';
    }
    var menuLabel = isMenuOpen ? 'Закрыть меню' : 'Открыть меню';
    return isChatOpen ? 'Закрыть чат' : menuLabel;
  }, [isMenuOpen, messengers, isChatOpen]);
  return /*#__PURE__*/React.createElement(AnimatedIconProvider, {
    activeIndex: isChatOpen || isMenuOpen ? 1 : 0
  }, /*#__PURE__*/React.createElement(Button, _extends({
    "aria-label": ariaLabel,
    className: cnStartButton(null),
    iconLeft: Icon,
    onClick: handleClick,
    onlyIcon: true,
    ref: ref,
    size: "m",
    tabIndex: 0,
    view: "tertiary"
  }, otherProps)));
});
var mapStateToProps = function mapStateToProps(store) {
  return {
    isChatOpen: selectIsChatOpen(store),
    isMenuOpen: selectIsMenuOpen(store),
    messengers: selectChatCofig(store).messengers
  };
};
export var OpenChat = connect(mapStateToProps, null, null, {
  forwardRef: true
})(OpenChatRender);